import { render, staticRenderFns } from "./flpMsgContainer.vue?vue&type=template&id=c00e479a&scoped=true&"
import script from "./flpMsgContainer.vue?vue&type=script&lang=js&"
export * from "./flpMsgContainer.vue?vue&type=script&lang=js&"
import style0 from "./flpMsgContainer.vue?vue&type=style&index=0&id=c00e479a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00e479a",
  null
  
)

export default component.exports